/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2021 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by kyang on 3/26/21.
 */
function ExternalIngestRunModalController(
    this: JS5Object,
    _: JS5Object,
    $q: JS5Object,
    ExternalMetadataService: JS5Object,
    ModalService: JS5Object,
) {

    //================//
    // Template Logic //
    //================//

    this.onCancelClicked = () => {
        this.dismiss({$value: 'cancel'});
    };

    this.onOkClicked = (fileValue: JS5Object) => {
        this.loadingIndicator.show = true;
        let fileName = fileValue.files[0].file.name;
        ExternalMetadataService.runMetadataSource(
            this.resolve.externalIngestSourceId,
            fileName,
            fileValue.results[0].fileText
        ).then(() => {
            this.close();
        }).catch((error: JS5Object) => {
            if (error.status === 400 && error.data.message) {
                ModalService.showMessageModal({
                    messageText: error.data.message,
                    pullCancelLeft: true,
                    title: 'Aggregation Error Message',
                    windowClass: 'wide-message-modal'
                });
            }
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };


    //=================//
    // File Validation //
    //=================//

    this.getFileExtensions = () => {
        return ['xml'];
    };

    this.getLocalFilePreValidationErrors = () => {
        // Doesn't add any local file filters
    };

    this.validateLocalFile = (fileItem: JS5Object) => {
        let deferred = $q.defer();
        let reader = new FileReader();
        let self = this;
        this.validationProgress = 1;

        reader.onload = (event: JS5Object) => {
            deferred.resolve({
                source: fileItem.file.name,
                errors: [],
                warnings: [],
                fileText: event.target.result,
            });
        };
        reader.onprogress = (event: JS5Object) => {
            self.validationProgress = Math.round((event.loaded * 100) / event.total);
        };
        reader.onerror = () => {
            deferred.resolve({
                source: fileItem.file.name,
                errors: [{
                    description: 'Browser failed to read the selected file',
                    severity: 'ERROR'
                }],
                warnings: [],
            });
        };

        reader.readAsText(fileItem._file);
        return deferred.promise;
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onInit = () => {
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
    };

    this.initializeLocalUploaderConfig = (fileUploaderConfig: JS5Object) => {
        // Doesn't require any additional initialization
    };
}

angular
    .module('prism-ui.components')
    .component(
        'externalIngestRunModal',
        {
            controller: ExternalIngestRunModalController,
            templateUrl: 'components/modal/externalIngest/externalIngestRunModal/external-ingest-run-modal-template.html',
            bindings: {
                resolve: '<',
                close: '&',
                dismiss: '&'
            }
        }
    );
